import { Alert } from "antd";

// Non-blocking failure: stale rows stay on screen, the banner says they may be
// out of date. Keeps a failed background refetch from wiping a usable table.
const ErrorBanner = ({
  message = "Couldn't refresh this list",
  description = "You're seeing the last loaded data.",
  onRetry,
}) => (
  <Alert
    banner
    className="mb-3"
    type="warning"
    showIcon
    message={message}
    description={description}
    action={
      onRetry && (
        <button className="text-blue underline" onClick={() => onRetry()}>
          Retry
        </button>
      )
    }
  />
);

export default ErrorBanner;
